import { useMutation } from "@apollo/client";
import { SelectField, toaster } from "evergreen-ui";
import { auth } from "firebase";
import React, { useContext, useState } from "react";
import Button from "src/Components/Button";
import { LanguageStore } from "src/Context/LanguageStore";
import { UPDATE_USER_PROFILE } from "src/Mutations/Users.share";
import { InputHooksType } from "src/Types/data-types";
import styled from "styled-components";

const Container = styled.form`
  ${(props) => props.theme.whiteBox};
  padding: 0px;
`;
const Title = styled.h1`
  ${(props) => props.theme.title};
  margin-bottom: 0.5rem;
`;

const Body = styled.div`
  padding: 1.5rem;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  background-color: ${(props) => props.theme.extraLightGreyColor};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

const ButtonHolder = styled.div``;

interface IProps {
  secretKey: InputHooksType;
  refetch: any;
  country: any;
}
const SetupSecretKey: React.SFC<IProps> = ({ secretKey, refetch, country }) => {
  const { dictionary } = useContext(LanguageStore);

  const [selectedCountry, setSelectedCountry] = useState("default");
  const [updateSecretKey] = useMutation(UPDATE_USER_PROFILE);

  const save = (e) => {
    e.preventDefault();
    toaster.warning("Making awesomeness!");
    updateSecretKey({
      variables: {
        id: auth().currentUser?.uid,
        object: {
          country: parseInt(selectedCountry),
        },
      },
    })
      .then(() => {
        toaster.closeAll();
        toaster.success("Hooray! Your account is setup!");
        refetch();
      })
      .catch((e) => {
        toaster.danger(e.message);
      });
  };

  const toggleCountry = (e) => {
    if (e.target.value === "default") {
      return;
    } else {
      setSelectedCountry(country[e.target.value].id);
    }
  };

  return (
    <Container>
      <Body>
        <Header>{dictionary.step} 3/3</Header>
        <Title>{dictionary.setupSecretKey}</Title>
        <SelectField label="Country" onChange={toggleCountry}>
          {selectedCountry === "default" && (
            <option value="default">Select a country</option>
          )}
          {country.map((co, index) => (
            <option value={index} key={index}>
              {co.name}
            </option>
          ))}
        </SelectField>
      </Body>
      <Footer>
        <ButtonWrapper>
          <ButtonHolder>
            <Button
              disabled={selectedCountry === "default"}
              onClick={save}
              label="Done!"
            />
          </ButtonHolder>
        </ButtonWrapper>
      </Footer>
    </Container>
  );
};

export default SetupSecretKey;
